import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.88rem 1.5rem;
  background-color: ${themeGet('colors.white')};
  border-radius: 0.5rem;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 50%;
  }
`;

export const Container = styled.div`
  height: 50%;
`;

export const Heading = styled.p`
  font-size: 1.5rem;
  line-height: 1.95rem;
  font-weight: ${themeGet('fontWeights.medium')};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2rem;
    line-height: 2.6rem;
  }
`;

export const Chart = styled.div`
  height: 50%;
  border: 0.4px solid #cccccc;
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  img {
    width: 6.3125rem;
    height: 8rem;
  }
`;

export const ChartHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const ToggleLabel = styled.label`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  cursor: pointer;
  min-height: 90px;

  span {
    text-align: right;
  }
`;

export const ToggleSwitch = styled.div`
  position: relative;
  width: 3.3125rem;
  height: 2rem;
  background: ${themeGet('colors.border-grey')};
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 29px;
    height: 29px;
    border-radius: 100%;
    top: 50%;
    left: 2px;
    background: ${themeGet('colors.white')};
    transform: translate(0, -50%);
  }
`;

export const Toggle = styled.input`
  opacity: 0;
  position: absolute;

  &:checked + ${ToggleSwitch} {
    background: ${themeGet('colors.secondary-velvet')};

    &:before {
      transform: translate(20px, -50%);
    }
  }
`;

export const ChartWrapper = styled.table`
  width: 100%;
  height: 100%;
  table-layout: fixed;
  position: relative;

  .sr-only {
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const Caption = styled.caption`
  margin-bottom: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 2rem;
  }
`;
